module.exports = __webpack_public_path__ + "static/img/professional_banner.377056b5.png";